import { SearchCriteria } from "./search-criteria";

export class GetInvoicesPayableByTheClientSearchCriteria extends SearchCriteria {
    public ClientId: number;

}
